// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__140vC","productName":"Table_productName__1Z6Zj"};